import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconNavArrowUp = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg viewBox="0 0 24 24" fill="currentcolor" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.268 7.804l-6.6 6.842a.603.603 0 000 .835l.581.602.015.015c.239.23.619.222.849-.015l5.861-6.078 5.861 6.078.015.015a.598.598 0 00.416.167c.157 0 .314-.06.432-.182l.58-.602a.6.6 0 000-.835L12.68 7.804a.974.974 0 00-1.412 0z"
        fill="currentcolor"
      />
    </svg>
  );
};

IconNavArrowUp.displayName = "IconNavArrowUp";
